import styled from "styled-components";

export const Editor = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`;

export const Bars = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    padding: 34px 34px 30px;
    transform: scale(1.2);
    transform-origin: top left;
    height: 330px;
    z-index: 1;
    position: relative;
    overflow-y: auto;
    margin-bottom: 70px;
    box-sizing: border-box;
    width: 83.334%;
`;

export const Btns = styled.div`
    overflow-y: auto;
    z-index: 2;
    position: relative;
    padding: 0 48px;
`;

export const Btn = styled.div`
    width: 90px;
    height: 90px;
    overflow: hidden;
    background-color: ${p => p.theme.c.active};
    margin: 4px 6px;
    padding: 2px;
    border-radius: 12px;
    font-size: 100px;
    opacity: 1;
    cursor: pointer;
    display: inline-block;

    &:hover {
        opacity: 0.7;
    }
    svg {
        width: 100px;
        height: 100px;
        display: flex;
        margin-top: 10px;
    }
`;

export const Break = styled.div`
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 100%;
`;
